import { WidgetBase } from "./WidgetBase";
import { WidgetTypes } from "./WidgetTypes";
import { WidgetController } from "../WidgetController";
import { PopupDesignTableComponent } from "../Popups/PopupDesignTableComponent";
import { WidgetDesignTableComponent } from "../Components/WidgetDesignTableComponent";

export class WidgetDesignTableProps {
    public viewType: string;
    public viewId: number;
    public title: string;
    public markup: string;
    public styles: string;
    public clientId: string;
    public rowClickPageId: number;
}

export class WidgetDesignTable extends WidgetBase {
    props: WidgetDesignTableProps;

    constructor(controller: WidgetController) {
        super(controller, 1, 2);
        this.props = new WidgetDesignTableProps();
    }

    getType(): WidgetTypes {
        return WidgetTypes.DesignTable;
    }

    loadProps(jsonProps: string): void {
        if (jsonProps && jsonProps.length > 0) {
            this.props = JSON.parse(jsonProps);
        }
    }

    saveProps(): string {
        return JSON.stringify(this.props);
    }

    createComponent(column: number, row: number, colSpan?: number, rowSpan?: number): HTMLElement {
        this.column = column;
        this.row = row;
        this.colSpan = colSpan ? colSpan : this.minColSpan;
        this.rowSpan = rowSpan ? rowSpan : this.minRowSpan;
        this.component = new WidgetDesignTableComponent({
            widget: this,
            viewType: this.props.viewType,
            viewId: this.props.viewId,
            title: this.props.title,
            markup: this.props.markup,
            styles: this.props.styles,
            clientId: this.props.clientId,
        });
        return this.component.render();
    }

    showPopup(): void {
        let popup = new PopupDesignTableComponent({ widget: this });
        document.body.appendChild(popup.render());
    }
}